import { Routes, Route, Navigate } from "react-router-dom";
import "./styles/index.css";
import Header from "./components/Header/Header.js";
import GameStatus from "./pages/GameStatus/GameStatus.js";
import GameSummary from "./pages/GameSummary/GameSummary.js";
import { FilterProvider } from "./components/Filter/FilterContext.js";
import Targets from "./pages/GameStatus/Targets/index.js";
  import {TopRank} from "./TopRank.js"

function App() {
  return (
    <FilterProvider>
      <div className="App">
            <Routes>
              <Route path="top-rank" element={<TopRank />}/>
              <Route path="*" element={
        <div className="system">
          <Header />
          <div className="contents">
            <Routes>
              <Route
                path="/"
                element={<Navigate to="/game-status/participants" replace />}
              />
              <Route path="top-rank" element={<TopRank />}/>
              <Route path="game-status/*" element={<GameStatus />} />
              <Route path="game-targets/*" element={<Targets />} />
              <Route path="game-summary/*" element={<GameSummary />} />
            </Routes>
          </div>
          <div className="system-bg"></div>
        </div>
              }/>
        </Routes>
      </div>
    </FilterProvider>
  );
}
export default App;
